export class IdelinkGlobalConstants {

	public static CLIENT_SECRET = 'Ideine';

	//* Clé GMAP Web pour Idelink local
	public static GOOGLE_MAP_API_KEY_DEVELOPMENT = 'AIzaSyAIOWNjADL1tLKrvx-WvBbzfpcMkuOZ1_Q';

	public static LOGS = {
		clientId: 'default',
		code: '0gs0wmhtjv0OMgywhyFBHmj2w9MaUhzazr1FaaF637ItxPIRurKKBw==',
		domain: 'https://idelink-functions-app.azurewebsites.net',
		uri: '/api/IdelinkBackOfficeLogs',
	};
}